module.exports = __webpack_public_path__ + "media/roy.547bde26.wav";